// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1B8zp","row":"styles_row__OdvbY"};